<template>
  <v-container class="py-10" id="zufriedenheit">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#f06914">Infrastruktur</div>
        <h2>Zufriedenheit mit der Infrastruktur</h2>
        <p>
          Fast die Hälfte aller Organisationen ist grundsätzlich mit ihrer
          IT-Infrastruktur zufrieden. <b>31%</b> der Organisationen geben aber
          an, dass sowohl beim Datenmanagement als auch bei der Qualität der
          Anwendungen Verbesserungsbedarf besteht. Sehr unzufrieden sind
          <b>35%</b> der Organisationen mit dem IT-Management in ihrer
          Organisation.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Technologieorientierung' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Infrastructurestats",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Zufriedenheit mit der IT Infrastruktur"
        },
        xAxis: {
          categories: [
            "Datenmanagement",
            "Qualität der IT-Anwendungen",
            "IT-Management"
          ],
          labels: {
            align: "left",
            reserveSpace: true,
            style: {
              fontSize: "12"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#d62b03", "#f06914", "#f0b414"],
        series: [
          {
            name: "Zufrieden",
            data: [45.46, 44.01, 48.66]
          },
          {
            name: "Könnte besser sein",
            data: [31.2, 31.08, 16.21]
          },
          {
            name: "Nicht zufrieden",
            data: [23.34, 24.92, 35.13]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Überblick",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
